import {
  segmentMemberColumnKeys,
  segmentMemberSchema,
} from "@redotech/redo-customer-segments-common/marketing/segments/segment-types";
import { segmentSchema } from "@redotech/redo-customer-segments-common/marketing/segments/segment-zod-schema";
import { SortDirection } from "@redotech/redo-views-common/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSegmentMembersBaseInputSchema = z.object({
  page: z.number().int().min(1),
  pageSize: z.number().int().min(1),
  sort: z
    .object({
      direction: createEnum(SortDirection),
      key: createEnum(segmentMemberColumnKeys),
    })
    .nullable(),
});
export type GetSegmentMembersBaseInput = z.infer<
  typeof getSegmentMembersBaseInputSchema
>;

export const getSegmentMembersPreviewInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("dynamic-segment-preview"),
    segment: segmentSchema,
    searchString: z.string().optional(),
  });
export type GetSegmentMembersPreviewInput = z.infer<
  typeof getSegmentMembersPreviewInputSchema
>;

export const getSegmentMembersExportInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("customer-group-export"),
    customerGroupId: zExt.objectId(),
  });
export type GetSegmentMembersExportInput = z.infer<
  typeof getSegmentMembersExportInputSchema
>;

export const getSegmentMembersStaticInputSchema =
  getSegmentMembersBaseInputSchema.extend({
    mode: z.literal("static-segment-preview"),
    customerGroupId: zExt.objectId(),
    searchString: z.string().optional(),
  });
export type GetSegmentMembersStaticInput = z.infer<
  typeof getSegmentMembersStaticInputSchema
>;

export const getSegmentMembers = {
  name: "getSegmentMembers" as const,
  input: z.union([
    getSegmentMembersPreviewInputSchema,
    getSegmentMembersExportInputSchema,
    getSegmentMembersStaticInputSchema,
  ]),
  output: z.array(segmentMemberSchema),
};
